import { render, staticRenderFns } from "./VaList.demo.vue?vue&type=template&id=e5d14e0e&"
import script from "./VaList.demo.vue?vue&type=script&lang=js&"
export * from "./VaList.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports